import type { AiBrowsingEvent } from "@/lib/ai/storage/types";

export function isAiDefaultEntryPath(pathname: string) {
	return pathname === "/plaza";
}

export function isAiLowSignalPath(pathname: string) {
	return (
		pathname === "/plaza" ||
		pathname === "/profile" ||
		pathname === "/discover" ||
		pathname === "/address"
	);
}

export function getAiBrowsingValueWeight(
	pathname: string,
	entityType?: AiBrowsingEvent["entityType"],
) {
	if (entityType === "token" || pathname.startsWith("/plaza/token/")) {
		return 100;
	}

	if (entityType === "address" || pathname.startsWith("/address/")) {
		return 95;
	}

	if (pathname.startsWith("/data") || pathname.startsWith("/scan")) {
		return 60;
	}

	if (pathname.startsWith("/plaza")) {
		return 10;
	}

	if (pathname.startsWith("/discover") || pathname.startsWith("/profile")) {
		return 5;
	}

	return 20;
}

export function buildAiBrowsingAggregateKey(
	event: Pick<AiBrowsingEvent, "pathname" | "entityType" | "entityId">,
) {
	if (event.entityType === "token" && event.entityId) {
		return `token:${event.entityId}`;
	}

	if (event.entityType === "address" && event.entityId) {
		return `address:${event.entityId}`;
	}

	return event.pathname;
}
